/* SelectTypeEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class SelectBoxEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
    }

    _init() {
        let dropDownData = {},
            dropDownValues = [];
        if (this._fieldName === "deviceBaseType") {
            dropDownData = _.get(this._itemData, "deviceTypeData", {});
            dropDownValues = Object.keys(dropDownData).map((item) => ({
                value: item,
                label: dropDownData[item],
            }));
        } else if (this._fieldName === "deviceVendor") {
            dropDownValues = Object.keys(this._itemData.vendorOsMap).map((item) => ({
                value: item,
                label: this._itemData.vendorOsMap[item].displayName,
            }));
            dropDownValues.unshift({value: "*", label: " Any"});
        } else if (this._fieldName === "deviceOs") {
            if (this._itemData["deviceVendor"] === "*") {
                const allVals = this.extractUniqueOsValues(this._itemData.vendorOsMap);
                dropDownValues = Object.keys(allVals).map((os) => ({
                    value: os,
                    label: allVals[os],
                }));
                dropDownValues.unshift({value: "*", label: " Any"});
            } else {
                const vendorObj = this._itemData.vendorOsMap[this._itemData["deviceVendor"]],
                    allValsSelected = this.extractUniqueOsValues({
                        [this._itemData["deviceVendor"]]: vendorObj,
                    });

                dropDownValues = Object.keys(allValsSelected).map((os) => ({
                    value: os,
                    label: allValsSelected[os],
                }));
                dropDownValues.unshift({value: "*", label: " Any"});
            }
        }
        dropDownValues.sort((a, b) => a.label.localeCompare(b.label));
        this.input.setOptions(dropDownValues);
        super._init();
    }

    hide() {}
    show() {}

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        return new SingleComboBoxControl({
            showFilter: false,
            darkTheme: true,
            adjustWidth: true,
            allowClear: false,
        });
    }

    /**
     *
     * @param {*} data
     * @returns Object with key value pairs of os key and os DisplayName for All Vendors
     */
    extractUniqueOsValues(data) {
        const osValueObj = {};

        for (const key of Object.keys(data)) {
            if (data[key].os) {
                for (const osName of Object.keys(data[key].os)) {
                    osValueObj[osName] = data[key].os[osName].displayName;
                }
            }
        }

        return osValueObj;
    }
}

module.exports = SelectBoxEditor;
